import React, { useState } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { DS } from '../ds';
import { AlinovaConstellation } from '../Visuals';
import { Btn, Label, H, P } from '../Primitives';
import { VideoBlock } from '../VideoBlock';
export const SolutionsSection = ({
  onCTA
}: {
  onCTA: (id: string) => void;
}) => {
  const [active, setActive] = useState(0);
  const solutions = [{
    tag: 'Para ortodoncistas',
    title: 'Tú planeas, nosotros fabricamos',
    body: 'Tienes la experiencia clínica y los archivos 3D. Nosotros nos encargamos de la fabricación con precisión milimétrica y una presentación que refleja el nivel de tu clínica.',
    steps: ['Envío archivos STL', 'Fabricación precisa', 'Entrega kit premium'],
    ideal: 'Ideal para ortodoncistas con flujo digital propio',
    videoBadge: 'Fabricación en acción',
    videoDesc: 'Del archivo STL al kit físico en tu clínica'
  }, {
    tag: 'Solución integral',
    title: 'Nos encargamos de todo',
    body: 'Desde el diagnóstico digital hasta la entrega completa. Incorpora ortodoncia invisible a tu clínica sin necesidad de infraestructura técnica adicional.',
    steps: ['Diagnóstico digital', 'Planificación validada', 'Fabricación y entrega'],
    ideal: 'Ideal para clínicas que inician con ortodoncia invisible',
    videoBadge: 'Flujo integral',
    videoDesc: 'Del diagnóstico a la entrega del kit completo',
    bgVideo: 'https://cdn.magicpatterns.com/uploads/6v9cNZPhBfNynrP1E39rKw/IMG_5853.mov'
  }, {
    tag: 'Máxima flexibilidad',
    title: 'Paga solo lo que necesitas',
    body: 'Componentes individuales según necesidad. Placas sueltas, retenedores o solo planificación. Sin compromisos de volumen ni paquetes cerrados.',
    steps: ['Selecciona componentes', 'Cotización inmediata', 'Producción puntual'],
    ideal: 'Ideal para clínicas con casos esporádicos o necesidades puntuales',
    videoBadge: 'Componentes a la carta',
    videoDesc: 'Flexibilidad total para cada caso',
    bgVideo: 'https://cdn.magicpatterns.com/uploads/brNfMwXM71ijwBn3MD8bhN/IMG_5866.mov#t=4,11',
    zoom: 1.35,
    translateY: '-15%',
    translateX: '-5%'
  }];
  const s = solutions[active];
  return <section id="soluciones" style={{
    padding: '56px 24px 80px',
    background: DS.color.ivory
  }} data-id="element-698" data-mp="2q0167znr2m41">
      <div style={{
      maxWidth: '1200px',
      margin: '0 auto'
    }} data-id="element-699" data-mp="2zzrwfp5a2eyb">
        {/* Header */}
        <div style={{
        marginBottom: '40px'
      }} data-id="element-700" data-mp="2v1i21grdnidr">
          <Label data-id="element-701" data-mp="2v0p517i8078t">Cómo trabajamos contigo</Label>
          <H size="lg" data-id="element-702" data-mp="39pv1inpobjd0">Tres formas de incorporar Alinova a tu clínica</H>
          <div style={{
          marginTop: '10px'
        }} data-id="element-703" data-mp="39s7f6ooef7k9">
            <P maxWidth="520px" data-id="element-704" data-mp="34qru4wm8111v">
              Cada clínica tiene un flujo diferente. Elige el modelo que
              se adapta a tu nivel de integración digital.
            </P>
          </div>
        </div>

        {/* Tabs */}
        <div style={{
        display: 'flex',
        gap: '10px',
        marginBottom: '32px',
        flexWrap: 'wrap'
      }} data-id="element-705" data-mp="3dtaxrixtzhp6">
          {solutions.map((sol, i) => <button key={i} onClick={() => setActive(i)} style={{
          padding: '10px 24px',
          borderRadius: DS.radius.pill,
          cursor: 'pointer',
          background: active === i ? DS.color.tealDeep : '#fff',
          color: active === i ? '#fff' : DS.color.tealDeep,
          border: `1.5px solid ${active === i ? DS.color.tealDeep : DS.color.tealDeep + '30'}`,
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 600,
          transition: `all 0.22s ${DS.ease.smooth}`,
          boxShadow: active === i ? DS.shadow.glowSm : 'none'
        }} onMouseEnter={e => {
          if (active !== i) {
            e.currentTarget.style.borderColor = DS.color.teal;
            e.currentTarget.style.color = DS.color.teal;
          }
        }} onMouseLeave={e => {
          if (active !== i) {
            e.currentTarget.style.borderColor = DS.color.tealDeep + '30';
            e.currentTarget.style.color = DS.color.tealDeep;
          }
        }} data-id="element-706" data-mp="654auiswmu1p" data-mpi={i}>
              {sol.tag}
            </button>)}
        </div>

        {/* Card principal */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '2px',
        borderRadius: DS.radius.cardLg,
        overflow: 'hidden',
        boxShadow: DS.shadow.featured
      }} data-id="element-707" data-mp="24wyue7upxywe">
          {/* Columna izquierda */}
          <div style={{
          background: `linear-gradient(160deg, ${DS.color.tealDeep} 0%, #07202a 100%)`,
          padding: '52px 48px',
          position: 'relative',
          overflow: 'hidden'
        }} data-id="element-708" data-mp="3uavk5nrowtga">
            <AlinovaConstellation width={300} height={300} opacity={0.06} style={{
            position: 'absolute',
            top: '-60px',
            right: '-60px',
            pointerEvents: 'none'
          }} data-id="element-709" data-mp="1h1n96c5y8itr" />
            <div style={{
            fontFamily: DS.font.body,
            fontSize: '11px',
            fontWeight: 700,
            color: DS.color.aquaLight,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            marginBottom: '14px'
          }} data-id="element-710" data-mp="t3y6xnxkp5n5">
              {s.tag}
            </div>
            <h3 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(1.5rem, 3vw, 2.2rem)',
            color: '#fff',
            lineHeight: 1.15,
            letterSpacing: '-0.02em',
            marginBottom: '18px'
          }} data-id="element-711" data-mp="2djjk4lcv7bl4">
              {s.title}
            </h3>
            <P light data-id="element-712" data-mp="eh4a4h5f5uza">{s.body}</P>

            <div style={{
            marginTop: '28px',
            marginBottom: '32px',
            padding: '14px 18px',
            borderRadius: '12px',
            background: 'rgba(75,199,210,0.08)',
            border: '1px solid rgba(75,199,210,0.15)',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }} data-id="element-713" data-mp="sesxbvmyle7i">
              <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: DS.color.aqua,
              flexShrink: 0
            }} data-id="element-714" data-mp="9h9jmepk37er" />
              <span style={{
              fontFamily: DS.font.body,
              fontSize: '13px',
              color: DS.color.aquaLight,
              fontWeight: 500,
              lineHeight: 1.4
            }} data-id="element-715" data-mp="38671xwtggnhg">
                {s.ideal}
              </span>
            </div>

            <Btn variant="ghost" size="md" onClick={() => onCTA('planes')} data-id="element-716" data-mp="1eoj8j9c0i4tz">
              Ver precios y planes →
            </Btn>
          </div>

          {/* Columna derecha */}
          <div style={{
          background: '#fff',
          padding: '52px 48px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }} data-id="element-717" data-mp="26f7485ux2i09">
            <div data-id="element-718" data-mp="22ciw60e11f4c">
              <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '11px',
              color: DS.color.teal,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              marginBottom: '28px'
            }} data-id="element-719" data-mp="22c13fdqkpj16">
                Flujo del proceso
              </div>

              <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 0
            }} data-id="element-720" data-mp="1dksrg8cipqks">
                {s.steps.map((step, i) => <div key={i} style={{
                display: 'flex',
                gap: 0,
                alignItems: 'stretch'
              }} data-id="element-721" data-mp="18n11vkzcigjr" data-mpi={i}>
                    <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginRight: '20px',
                  width: '24px',
                  flexShrink: 0
                }} data-id="element-722" data-mp="21by7oomdekvm">
                      <div style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    background: DS.color.tealDeep,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: DS.font.body,
                    fontSize: '11px',
                    fontWeight: 700,
                    color: '#fff'
                  }} data-id="element-723" data-mp="1mkfuszot56gh">
                        {i + 1}
                      </div>
                      {i < s.steps.length - 1 && <div style={{
                    width: '1px',
                    flex: 1,
                    background: `linear-gradient(${DS.color.aqua}, ${DS.color.border})`,
                    margin: '4px 0',
                    minHeight: '32px'
                  }} data-id="element-724" data-mp="3aiqcu1ppd57c" />}
                    </div>
                    <div style={{
                  paddingBottom: i < s.steps.length - 1 ? '20px' : 0,
                  paddingTop: '2px'
                }} data-id="element-725" data-mp="3t8gaqxori73h">
                      <div style={{
                    fontFamily: DS.font.body,
                    fontSize: '15px',
                    fontWeight: 600,
                    color: DS.color.ink
                  }} data-id="element-726" data-mp="104mthbmyz19x">
                        {step}
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>

            <div style={{
            marginTop: '32px'
          }} data-id="element-727" data-mp="1itjmzdajlpr3">
              <VideoBlock badge={s.videoBadge} title={s.title} description={s.videoDesc} bgVideo={s.bgVideo} zoom={s.zoom} translateY={s.translateY} translateX={s.translateX} data-id="element-728" data-mp="1nuz8t7kjo0aj" />
            </div>
          </div>
        </div>

        {/* CTA ¿Tienes dudas? */}
        <div style={{
        marginTop: '32px',
        padding: '20px 28px',
        borderRadius: '16px',
        background: DS.color.white,
        border: `1px solid ${DS.color.border}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap'
      }} data-id="element-729" data-mp="3dc4hekyiid5b">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }} data-id="element-730" data-mp="3w1sx56tsln03">
            <div style={{
            width: '38px',
            height: '38px',
            borderRadius: '50%',
            background: DS.color.mint,
            border: `1px solid ${DS.color.aqua}40`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }} data-id="element-731" data-mp="3r2zkthq8s21i">
              <MessageCircleIcon size={18} color={DS.color.teal} data-id="element-732" data-mp="12p11dy3510hm" />
            </div>
            <div data-id="element-733" data-mp="16qvz6slv0vqn">
              <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '15px',
              color: DS.color.ink
            }} data-id="element-734" data-mp="16rfiacn8xq69">
                ¿Tienes dudas sobre qué modalidad elegir?
              </div>
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '13px',
              color: DS.color.muted,
              marginTop: '2px'
            }} data-id="element-735" data-mp="j0ie5m1ozx5k">
                Un asesor te responde en minutos por WhatsApp.
              </div>
            </div>
          </div>
          <a href={DS.wa} target="_blank" rel="noopener noreferrer" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '11px 24px',
          borderRadius: DS.radius.pill,
          background: DS.color.teal,
          color: '#fff',
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          textDecoration: 'none',
          transition: `all 0.22s ${DS.ease.smooth}`,
          whiteSpace: 'nowrap'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = DS.color.tealDeep;
        }} onMouseLeave={e => {
          e.currentTarget.style.background = DS.color.teal;
        }} data-id="element-736" data-mp="exlvjvc5k11m">
            <MessageCircleIcon size={15} aria-hidden="true" data-id="element-737" data-mp="e4633nidlxal" />
            Hablar por WhatsApp
          </a>
        </div>
      </div>
    </section>;
};